import { useState, useEffect, useCallback } from "react";
import { getUsers } from "../Services/ReportingService.js";
import SearchBar from "../Components/Search.js";
import MainContainer from "../Components/MainContainer.js";
import { connect } from "react-redux";
import { userActions } from "../_actions/user.actions.js";
import PuffLoader from "react-spinners/PuffLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserTimes, faUserEdit, faEdit } from "@fortawesome/free-solid-svg-icons";
import "../style/ReportCard.css";
import "../style/Search.css";
import "../style/Home.css";
import "../style/UserSummary.css";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import UserFormModal from "../Components/UserFormModal.js";
import MobileInfoModal from "../Components/MobileInfoModal.js";
import { Box } from "@material-ui/core";
import { isMobileScreen } from "../Util/Utils.js";
import Notification from "../Components/Notification.js";
import { getBusinessUnits } from "../Services/ReportingService.js";
import DynamicTable from "../Components/DynamicTable.js";
import { getLicenseBundles } from "../Services/ReportingService";

const UserSummary = (props) => {
  const [employeeList, setEmployeeList] = useState([]);
  const [businessUnitsList, setBusinessUnitsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentEditEmployee, setCurrentEditEmployee] = useState({});
  const [currentShownEmployee, setCurrentShownEmployee] = useState({});
  const [showRemoveUserFormModal, setShowRemoveUserFormModal] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showMobileInfoModal, setShowMobileInfoModal] = useState(false);
  const [showDynamicUpdateUserModal, setShowDynamicUpdateUserModal] = useState(false);
  const [dynamicUpdateUserType, setDynamicUpdateUserType] = useState("");
  const [companyToBusinessUnitMap, setCompanyToBusinessUnitMap] = useState(new Map());
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [bundlesList, setBundlesList] = useState([]);
  const isMobile = isMobileScreen();
  const notifyFranchisee = false;

  //TODO: Make search bar search all columns on user page

  const initializeEmployeeList = useCallback(
    (employeeList) => {
      let sortedEmployeeList = employeeList;
      sortedEmployeeList.sort((employeeOne, employeeTwo) => {
        const businessUnitOne =
          companyToBusinessUnitMap.get(employeeOne.userBusinessUnit) || employeeOne.userBusinessUnit;
        const businessUnitTwo =
          companyToBusinessUnitMap.get(employeeTwo.userBusinessUnit) || employeeTwo.userBusinessUnit;
        if (businessUnitOne === businessUnitTwo) {
          return employeeOne.userBundleName.localeCompare(employeeTwo.userBundleName);
        } else {
          return businessUnitOne.localeCompare(businessUnitTwo);
        }
      });
      return sortedEmployeeList;
    },
    [companyToBusinessUnitMap]
  );

  useEffect(() => {
    const getCompanyToBusinessUnitMap = () => {
      getBusinessUnits().then((response) => {
        if (response) {
          const newCompanyToBusinessUnitMap = new Map();
          const responseBUs = response.filter((bu) => !bu.businessUnitName.toLowerCase().includes("deprecated"));
          responseBUs.push({
            businessUnitGuid: null,
            businessUnitName: "Support Center",
            bcCompanyName: "Support Center",
            companyNumber: "Support Center",
            usingBc: null,
          });
          responseBUs.push({
            businessUnitGuid: null,
            businessUnitName: "Staffing Solutions",
            bcCompanyName: "Staffing Solutions",
            companyNumber: "Staffing Solutions",
            usingBc: null,
          });
          responseBUs.forEach((bu) => {
            newCompanyToBusinessUnitMap.set(bu.bcCompanyName, bu.businessUnitName);
          });
          setCompanyToBusinessUnitMap(newCompanyToBusinessUnitMap);
        }
      });
    };
    getCompanyToBusinessUnitMap();
  }, []);

  useEffect(() => {
    getLicenseBundles().then((response) => {
      if (response) {
        setBundlesList(response);
      }
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    var result = [];
    var nameTest;
    var buTest;
    if (!searchQuery) {
      setFilteredPosts(employeeList);
      setLoading(false);
    }

    nameTest = employeeList.filter((employee) => {
      const employeeNames = employee.userFullName.toLowerCase();
      return employeeNames.includes(searchQuery);
    });

    buTest = employeeList.filter((employee) => {
      const businessUnits = companyToBusinessUnitMap.get(employee.userBusinessUnit)
        ? companyToBusinessUnitMap.get(employee.userBusinessUnit).toLowerCase()
        : employee.userBusinessUnit.toLowerCase();
      return businessUnits.includes(searchQuery);
    });
    nameTest.forEach((employee) => {
      result.push(employee);
    });
    buTest.forEach((employee) => {
      if (!result.some((existingEmployee) => employee.userDomainName === existingEmployee.userDomainName)) {
        result.push(employee);
      }
    });

    setFilteredPosts(result);
    setLoading(false);
  }, [employeeList, searchQuery, companyToBusinessUnitMap]);

  useEffect(() => {
    setLoading(true);
    if (companyToBusinessUnitMap.size > 0) {
      getUsers(sessionStorage.getItem("userId")).then((response) => {
        if (response.usersList) {
          setEmployeeList(initializeEmployeeList(response.usersList));
        }
        if (response.businessUnitsList) {
          setBusinessUnitsList(
            response.businessUnitsList
              .filter((bu) => bu !== "Arete CA")
              .filter((bu) => !bu.toLowerCase().includes("deprecated"))
          );
        }
        setLoading(false);
      });
    }
  }, [companyToBusinessUnitMap, initializeEmployeeList]);

  const determineWhichUpdateUserToDisplayAndDisplay = (employee) => {
    if (
      employee.userBusinessUnit === "Kansas City" ||
      employee.userBusinessUnit === "Minnesota" ||
      employee.userBusinessUnit === "Silicon Valley" ||
      employee.userBusinessUnit === "Northern Virginia"
    ) {
      setShowDynamicUpdateUserModal(true);
      setDynamicUpdateUserType("NotFranchise");
      setCurrentEditEmployee(employee);
    } else {
      setShowDynamicUpdateUserModal(true);
      setDynamicUpdateUserType("Franchise");
      setCurrentEditEmployee(employee);
    }
  };

  const openMobileModal = (employee) => {
    setShowMobileInfoModal(true);
    setCurrentShownEmployee(employee);
  };

  const usersTableHeader = () => {
    return (
      <>
        {isMobile ? (
          <>
            <td className="col-2"></td>
            <td className="col-5">Employee Name</td>
            <td className="col-5">Job Title</td>
          </>
        ) : (
          <>
            <td className="col-1"></td>
            <td className="col-2">Employee Name</td>
            <td className="col-2">Employee Email</td>
            <td className="col-2">Business Unit</td>
            <td className="col-2">Job Title</td>
            <td className="col-2">License Bundle</td>
            <td className="col-1"></td>
          </>
        )}
      </>
    );
  };

  const usersTableRows = () => {
    return filteredPosts.map((employee) => {
      return (
        <>
          {isMobile ? (
            <td className="col-2">
              <button className="btn btn-warning float-right" onClick={() => openMobileModal(employee)}>
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          ) : (
            <td className="col-1">
              <button
                className="btn btn-warning float-right"
                onClick={() => determineWhichUpdateUserToDisplayAndDisplay(employee)}
              >
                <FontAwesomeIcon icon={faUserEdit} />
              </button>
            </td>
          )}
          {isMobile ? (
            <td className="col-5">{employee.userFullName}</td>
          ) : (
            <td className="col-2">{employee.userFullName}</td>
          )}
          {!isMobile && <td className="col-2">{employee.userPrimaryEmail}</td>}
          {!isMobile && employee.userBusinessUnit !== "" && (
            <td className="col-2">
              {companyToBusinessUnitMap.get(employee.userBusinessUnit) || employee.userBusinessUnit}
            </td>
          )}
          {!isMobile && employee.userBusinessUnit === "" && <td className="col-2">Home Office</td>}
          {isMobile ? (
            <td className="col-5">{employee.userJobTitle}</td>
          ) : (
            <td className="col-2">{employee.userJobTitle}</td>
          )}
          {!isMobile && <td className="col-2">{employee.userBundleName}</td>}
          {!isMobile && (
            <td className="col-1">
              <button
                className="btn btn-danger float-right"
                onClick={() => {
                  setShowRemoveUserFormModal(true);
                  setCurrentEditEmployee(employee);
                }}
              >
                <FontAwesomeIcon icon={faUserTimes} />
              </button>
            </td>
          )}
        </>
      );
    });
  };

  return (
    <MainContainer>
      <Notification />
      {!loading && (
        <Box>
          <div className="d-flex flex-row justify-content-between">
            <strong className="page-title" data-testid="bundle-heading">
              Users
            </strong>
            <div className="addUserButton">
              <button
                type="button"
                onClick={() => setShowAddUserModal(true)}
                className={`btn btn-dark mx-lg-auto float-right float-lg-none w-100`}
              >
                <FontAwesomeIcon icon={faCheck} /> Add User
              </button>
            </div>
          </div>
          <div>
            <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          </div>
        </Box>
      )}

      <div className="col-12 text-center">
        <div className={`d-flex ${loading ? "" : "d-none"}`}>
          <div className="d-flex flex-row">
            <strong className="page-title" data-testid="bundle-heading">
              Users
            </strong>
          </div>
        </div>
        <div className={`d-flex ${loading ? "" : "d-none"}`}>
          <div className={`mx-auto d-flex`}>
            <PuffLoader size={150} color={"#FFFFFF"} loading={loading} />
          </div>
        </div>
        {!loading && (
          <>
            <DynamicTable header={usersTableHeader()} rows={usersTableRows()} height={650} />
          </>
        )}
      </div>
      {!loading && (
        <>
          <UserFormModal
            mode="remove"
            show={showRemoveUserFormModal}
            onHide={() => setShowRemoveUserFormModal(false)}
            usersList={employeeList}
            employee={currentEditEmployee}
            notifyFranchisee={notifyFranchisee}
            bundlesList={bundlesList}
          />
          <UserFormModal
            mode="add"
            show={showAddUserModal}
            onHide={() => setShowAddUserModal(false)}
            employee={currentEditEmployee}
            businessUnitsList={businessUnitsList}
            businessUnitName={
              companyToBusinessUnitMap.get(currentEditEmployee.userBusinessUnit) || currentEditEmployee.userBusinessUnit
            }
            notifyFranchisee={notifyFranchisee}
            typeOfModal={dynamicUpdateUserType}
            bundlesList={bundlesList}
          />
          <UserFormModal
            mode="update"
            show={showDynamicUpdateUserModal}
            onHide={() => setShowDynamicUpdateUserModal(false)}
            employee={currentEditEmployee}
            businessUnitsList={businessUnitsList}
            businessUnitName={
              companyToBusinessUnitMap.get(currentEditEmployee.userBusinessUnit) || currentEditEmployee.userBusinessUnit
            }
            notifyFranchisee={notifyFranchisee}
            typeOfModal={dynamicUpdateUserType}
            bundlesList={bundlesList}
          />
          <MobileInfoModal
            show={showMobileInfoModal}
            onHide={() => setShowMobileInfoModal(false)}
            employee={currentShownEmployee}
            usersList={employeeList}
            businessUnitsList={businessUnitsList}
            notifyFranchisee={notifyFranchisee}
          />
        </>
      )}
    </MainContainer>
  );
};

function mapStateToProps(state) {
  const { authentication } = state;
  const { crmUser } = authentication;
  return { crmUser };
}

const actionCreators = {
  logout: userActions.logout,
};

const connectedUserSummaryPage = connect(mapStateToProps, actionCreators)(UserSummary);
export { connectedUserSummaryPage as UserSummary };
